export const awsServerRegion =[
    { value: "us-east-2", label: "us-east-2" },
    { value: "us-east-1", label: "us-east-1" },
    { value: "us-west-1", label: "us-west-1" },
    { value: "us-west-2", label: "us-west-2" },
    { value: "af-south-1", label: "af-south-1" },
    { value: "ap-east-1", label: "ap-east-1" },
    { value: "ap-east-2", label: "ap-east-2" },
    { value: "ap-south-1", label: "ap-south-1" },
    { value: "ap-south-2", label: "ap-south-2" },
    { value: "ap-southeast-1", label: "ap-southeast-1" },
    { value: "ap-southeast-2", label: "ap-southeast-2" },
    { value: "ap-southeast-3", label: "ap-southeast-3" },
    { value: "ap-southeast-5", label: "ap-southeast-5" },
    { value: "ap-southeast-4", label: "ap-southeast-4" },
    { value: "ap-northeast-3", label: "ap-northeast-3" },
    { value: "ap-northeast-2", label: "ap-northeast-2" },
    { value: "ap-southeast-7", label: "ap-southeast-7" },
    { value: "ap-northeast-1", label: "ap-northeast-1" },
    { value: "ca-west-1", label: "ca-west-1" },
    { value: "ca-central-1", label: "ca-central-1" },
    { value: "eu-central-1", label: "eu-central-1" },
    { value: "eu-west-1", label: "eu-west-1" },
    { value: "eu-west-2", label: "eu-west-2" },
    { value: "eu-west-3", label: "eu-west-3" },
    { value: "eu-south-1", label: "eu-south-1" },
] 